export default class WorkerMinimumPayRateRequest {
    workerId: string;
    date: string;
}
